import { useEffect, useRef } from "react";
import { FILTERS } from "react-filerobot-image-editor-headless";
import { Image as KImage, Layer, Stage } from "react-konva";

export const filters = {
  Aden: FILTERS.Aden,
  Amaro: FILTERS.Amaro,
  Ashby: FILTERS.Ashby,
  BlackAndWhite: FILTERS.BlackAndWhite,
  Brannan: FILTERS.Brannan,
  Brooklyn: FILTERS.Brooklyn,
  Charmes: FILTERS.Charmes,
  Clarendon: FILTERS.Clarendon,
  Crema: FILTERS.Crema,
  Dogpatch: FILTERS.Dogpatch,
  Earlybird: FILTERS.Earlybird,
  Gingham: FILTERS.Gingham,
  Ginza: FILTERS.Ginza,
  Hefe: FILTERS.Hefe,
  Helena: FILTERS.Helena,
  Hudson: FILTERS.Hudson,
  Juno: FILTERS.Juno,
  Kelvin: FILTERS.Kelvin,
  Lark: FILTERS.Lark,
  LoFi: FILTERS.LoFi,
  Ludwig: FILTERS.Ludwig,
  Maven: FILTERS.Maven,
  Mayfair: FILTERS.Mayfair,
  Moon: FILTERS.Moon,
  Nashville: FILTERS.Nashville,
  NinteenSeventySeven: FILTERS.NinteenSeventySeven,
  Perpetua: FILTERS.Perpetua,
  Reyes: FILTERS.Reyes,
  Rise: FILTERS.Rise,
  Sierra: FILTERS.Sierra,
  Skyline: FILTERS.Skyline,
  Slumber: FILTERS.Slumber,
  Stinson: FILTERS.Stinson,
  Sutro: FILTERS.Sutro,
  Toaster: FILTERS.Toaster,
  Valencia: FILTERS.Valencia,
  Vesper: FILTERS.Vesper,
  Walden: FILTERS.Walden,
  Willow: FILTERS.Willow,
  XPro2: FILTERS.XPro2,
};

// Organized filter categories based on style and effect analysis
export const getFilterCategories = (t: (key: string) => string) => ({
  vintageRetro: {
    name: t("studio.effects.categories.vintage_retro"),
    filters: [
      "Aden",
      "Walden",
      "Earlybird",
      "NinteenSeventySeven",
      "Toaster",
      "Rise",
    ],
  },
  modernClean: {
    name: t("studio.effects.categories.modern_clean"),
    filters: ["Clarendon", "Hudson", "Juno", "Lark", "Ludwig", "Amaro"],
  },
  artisticCreative: {
    name: t("studio.effects.categories.artistic_creative"),
    filters: ["Ashby", "Charmes", "Helena", "Mayfair", "Nashville", "Vesper"],
  },
  boldDramatic: {
    name: t("studio.effects.categories.bold_dramatic"),
    filters: ["Kelvin", "Brannan", "Dogpatch", "Hefe", "LoFi", "XPro2"],
  },
  monochrome: {
    name: t("studio.effects.categories.monochrome"),
    filters: ["BlackAndWhite", "Moon", "Willow", "Slumber"],
  },
  softSubtle: {
    name: t("studio.effects.categories.soft_subtle"),
    filters: [
      "Gingham",
      "Ginza",
      "Sierra",
      "Valencia",
      "Maven",
      "Reyes",
      "Brooklyn",
      "Crema",
    ],
  },
});

// Legacy export for backwards compatibility
export const filterCategories = getFilterCategories((key) => key);

export const FilterPreview = ({
  imageElement,
  filterName,
  className = "",
}: {
  imageElement: HTMLImageElement;
  filterName: string;
  className?: string;
}) => {
  const imageRef = useRef<any>(null);
  const targetWidth = 100;
  const targetHeight = 100;

  const imgWidth = imageElement.width;
  const imgHeight = imageElement.height;

  const scale = Math.max(targetWidth / imgWidth, targetHeight / imgHeight);
  const newWidth = imgWidth * scale;
  const newHeight = imgHeight * scale;

  const offsetX = (newWidth - targetWidth) / 2;
  const offsetY = (newHeight - targetHeight) / 2;

  useEffect(() => {
    if (imageRef.current) {
      imageRef.current.cache();
      imageRef.current.getLayer()?.batchDraw();
    }
  }, [imageElement, filterName]);

  return (
    <Stage width={targetWidth} height={targetHeight} className={className}>
      <Layer>
        <KImage
          ref={imageRef}
          image={imageElement}
          filters={[(filters as any)[filterName]]}
          x={-offsetX}
          y={-offsetY}
          width={newWidth}
          height={newHeight}
        />
      </Layer>
    </Stage>
  );
};
